<template>
  <c-button :mb="{ base: 'md', sm: '0' }" left-icon="calendar" @click="addToCalendar">
    {{ label }}
  </c-button>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { atcb_action } from "add-to-calendar-button";
import momentTz from "moment-timezone";
import { CButton } from "@chakra-ui/vue";

export default defineComponent({
  components: {
    CButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    iCalFileName: {
      type: String,
      required: false,
    },
  },
  methods: {
    addToCalendar() {
      const date = momentTz(this.date, "D.M.YYYY").format("YYYY-MM-DD");

      atcb_action({
        name: this.title,
        description: this.description,
        startDate: date,
        options: ["Apple", "Google", "iCal", "Microsoft365", "Outlook.com"],
        iCalFileName: this.iCalFileName || "calendar-event",
      });
    },
  },
});
</script>
